import { getRuleFiltersConfigBySection } from '@kw/quokka-ui';
import { FiltersAndTable } from '../FiltersAndTable';

interface IProps {
  ruleSummaries: object;
  analysisId: string;
}

export function BehaviorsTab({ ruleSummaries, analysisId }: IProps) {
  const filtersConfig = getRuleFiltersConfigBySection({ ruleSummaries, section: 'behaviors' });

  return <FiltersAndTable filtersConfig={filtersConfig} analysisId={analysisId} data={ruleSummaries} />;
}
